import React from "react";
import isEmpty from "lodash/isEmpty";
import styled from 'styled-components';
import PropTypes from "prop-types";

import config from "../../Config";
import { cutString } from "../../util/cutString";
import i18n from "../../i18n"

const Container = styled.div`
	height: 220px;
	width: 49.5%;
	background-color: #fff;
	display: inline-flex;
	border-bottom: 1px solid #f0f0f0;
	border-right: 1px solid #f0f0f0;
	flex-direction: column;
	box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.21);
`;

const Header = styled.div`
	margin-top: 5px;
	margin-bottom: 5px;
	height: 22px;
	text-align: start;
`;

const ImgWrapper = styled.div`
	height: 120px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Description = styled.div`
	height: 60px;
	display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const Title = styled.div`
	margin-bottom: 5px;
	font-size: 14px;
	padding-left: 3px;
	padding-right: 3px;
`;

const BidBtn = styled.button`
	width: 60px;
  	height: 30px;
  	border-radius: 4px;
  	background-color: #ffffff;
  	color: #f22c2c;
  	border: solid 1px #dedede;
  	cursor: pointer;
`;

const DateBox = styled.div`
	background-image: url(${config.MRBIDNWIN_S3_IMAGE_URL}/timer_with_banner.svg);
	background-size: contain;
	background-repeat: no-repeat;
	padding-left: 20px;
	font-size: 8px;
	font-family: montserratRegular
	display: flex;
    align-items: center;
    height: 22px;
`;

function getDate(date){
	let x = date.split("at ");
	if(!isEmpty(x[1])){
		return x[1]
	}
	return "UPCOMING";
}

const ProductCard = ({title, imgUrl, price, date, onClick, style, live, boderClass}) => {
	return(
		<Container style={style} className={`${boderClass} item`} onClick={onClick}>
			<Header>
				{
					live ? <img src={`${config.MRBIDNWIN_S3_IMAGE_URL}/`+i18n.t("live_now")+`.`+i18n.t("live_now_file_type")} alt="live-product" /> : <DateBox>{getDate(date)}</DateBox>
				}
			</Header>
		   <ImgWrapper>
		   		<img src={imgUrl} style={{width:"70%", maxHeight:'115px'}} alt="product"/>
		   </ImgWrapper>
		   <Description>
		   		<Title className="montserratSemiBold">
		   			{cutString(title, 18)}
		   		</Title>
		   		<BidBtn onClick={onClick}>
		   		 	<span className="montserratRegular">{i18n.t("Bid")}</span>
		   		</BidBtn>
		   </Description>
		</Container>
	)
}

ProductCard.propTypes = {
	style: PropTypes.object,
	redirectUrl: PropTypes.string,
	title: PropTypes.string,
	date: PropTypes.string,
	price: PropTypes.string,
	imgUrl: PropTypes.string,
	currencySymbol: PropTypes.string,
	onClick: PropTypes.func
}

ProductCard.defaultProps = {
	style: {},
	imgUrl: `${config.MRBIDNWIN_S3_IMAGE_URL}/ic_auction_avatar.svg`
}

export default ProductCard;



// WEBPACK FOOTER //
// ./src/components/card/ProductCard.js